/*
 * @Author: edvardchen
 * @Date: 2018-01-24 14:53:39
 * @Last Modified by: edvardchen
 * @Last Modified time: 2018-01-24 14:54:02
 */

// @flow
const rSelfHostPath = /^\/(?!\/)/;
export default (path: string) => rSelfHostPath.test(path);
